import { createSelector } from "@ngrx/store";
import { selectRouteNestedParam } from "./router.selectors";

export const selectMlid = createSelector(
	selectRouteNestedParam("mlid"),
	(mlid) => (mlid as string) || undefined
);
